import type { Model, Product } from '../types'
export const MASCOT = '/mascots/frosty.png'
export function allProducts(model: Model): Product[] {
  const found = new Map<string, Product>()
  const visit = (value: unknown) => {
    if (Array.isArray(value)) { value.forEach(visit); return }
    if (!value || typeof value !== 'object') return
    if ('fin' in value && 'href' in value && 'brand' in value && typeof value.fin === 'string') {
      const product = value as Product
      found.set(product.fin, product)
    } else Object.values(value).forEach(visit)
  }
  visit(model)
  return [...found.values()]
}
